
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import axios from "axios";
const video = ref();
const canvas = ref();
const captures: any = ref([]);
const isCameraOpen = ref(false);
const listBlogs = ref();
const listCourses = ref();
const listSyllabuses = ref();
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default defineComponent({
  name: "verify",
  components: {},
  data() {
    return {
      imageUrl: process.env.VUE_APP_API_URL,
      checkPermission: 0,
      preview: false,
      urlImage: "",
      toc: false,
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    
      // axios
      //   .get(
      //     process.env.VUE_APP_API_URL +
      //       "/api/v1/blogs" +
      //       "?limit=3&page=0&asc=true&sortBy=1"
      //   )
      //   .then(({ data }) => {
          // console.log(data);
      //     listBlogs.value = data.result;
      //   })
      //   .catch(({ error }) => {
          // console.log(error);
      //   });
    });
    return {
      video,
      canvas,
      captures,
      isCameraOpen,
      listBlogs,
      listCourses,
      listSyllabuses,
    };
  },
  mounted() {
    this.createCameraElement();
  },
  methods: {
    setAltImg(event) {
      event.target.src = "media/image-app/no-image.svg";
    },
    todo() {
      isCameraOpen.value = true;
      this.createCameraElement();
      // window.setInterval(() => {
      //   this.capture();
      // }, 2000); // interval set to one sec.
    },
    checkCamera() {
      this.checkPermission = window.setInterval(() => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ video: true, audio: false })
            .then((stream) => {
              // console.log(stream);
            })
            .catch((error) => {
              clearInterval(this.checkPermission);
              // console.log(error);
              Swal.fire({
                title: "กรุณาให้สิทธิ webcam ในการทำข้อสอบ",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#323563",
                cancelButtonColor: "#d33",
                confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
                allowOutsideClick: false,
                // cancelButtonText: "ยกเลิก",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.createCameraElement();
                }
              });
            });
        }
      }, 2000);
    },
    createCameraElement() {
      isCameraOpen.value = true;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: false })
          .then((stream) => {
            video.value.srcObject = stream;
            video.value.play();
            this.checkCamera();
          })
          .catch((error) => {
            // console.log(error);
            Swal.fire({
              title: "กรุณาให้สิทธิ webcam ในการทำข้อสอบ",
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#323563",
              cancelButtonColor: "#d33",
              confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
              allowOutsideClick: false,
              // cancelButtonText: "ยกเลิก",
            }).then((result) => {
              if (result.isConfirmed) {
                this.createCameraElement();
              }
            });
          });
      }
    },
    stopCameraStream() {
      video.value = video.value.srcObject.getTracks();
      video.value.forEach((track) => {
        track.stop();
      });
    },
    capture() {
      /* eslint-disable */
      canvas.value = this.$refs.canvas;
      // console.log(canvas.value);
      var context: any = canvas.value
        .getContext("2d")
        .drawImage(this.video, 0, 0, 640, 480);
      // console.log(canvas.value.toDataURL("image/png"));
      const url = canvas.value.toDataURL("image/png");
      if (url) {
        this.urlImage = url;
        this.preview = true;
      }
      // fetch(url)
      //   .then((res) => res.blob())
      //   .then(async (blob) => {
      //     const file = new File([blob], "File name", { type: "image/png" });
      //     const formData = new FormData();
      //     formData.append("imageFace", file);
      //     formData.append("examRoomCode", this.$route.params.examRoomCode + "");
      //     await axios
      //       .post(
      //         process.env.VUE_APP_API_URL + "/enterExamRoomRegister",
      //         formData,
      //         {
      //           headers: {
      //             token: localStorage.getItem("id_token"),
      //           },
      //         }
      //       )
      //       .then((response) => {
              // console.log(response);
      //         if (response.data.code == 200) {
      //           this.$router.push({
      //             name: "exam-detail",
      //             params: { id: response.data.data.examRoomId },
      //           });
      //         } else {
      //           Swal.fire({
      //             text: response.data.message,
      //             icon: "error",
      //             buttonsStyling: false,
      //             confirmButtonText: "ลองใหม่ภายหลัง!",
      //             customClass: {
      //               confirmButton: "btn fw-semobold btn-light-danger",
      //             },
      //           });
      //         }
      //       })
      //       .catch((error) => {
      //         Swal.fire({
      //           text: error.message,
      //           icon: "error",
      //           buttonsStyling: false,
      //           confirmButtonText: "ลองใหม่ภายหลัง!",
      //           customClass: {
      //             confirmButton: "btn fw-semobold btn-light-danger",
      //           },
      //         });
      //       });
      //   });
    },
    submitCapture() {
      if (this.urlImage) {
        fetch(this.urlImage)
          .then((res) => res.blob())
          .then(async (blob) => {
            const file = new File([blob], "File name", { type: "image/png" });
            const formData = new FormData();
            formData.append("imageFace", file);
            formData.append(
              "examRoomCode",
              this.$route.params.examRoomCode + ""
            );
            await axios
              .post(
                process.env.VUE_APP_API_URL + "/enterExamRoomRegister",
                formData,
                {
                  headers: {
                    token: localStorage.getItem("id_token"),
                  },
                }
              )
              .then((response) => {
                // console.log(response);
                if (response.data.code == 200) {
                  this.$router.push({
                    name: localStorage.getItem("typeLogin") === "idcard" ? "exam-detail-noheader" : "exam-detail",
                    params: { id: response.data.data.examRoomId },
                  });
                } else {
                  Swal.fire({
                    text: response.data.message,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "ลองใหม่ภายหลัง!",
                    customClass: {
                      confirmButton: "btn fw-semobold btn-light-danger",
                    },
                  });
                }
              })
              .catch((error) => {
                Swal.fire({
                  text: error.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "ลองใหม่ภายหลัง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                });
              });
          });
      } else {
        Swal.fire({
          text: "ไม่พบข้อมูลรูปยืนยันตัวตน",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.checkPermission);
    let tracks = video.value.srcObject.getTracks();
    // console.log(tracks);
    tracks.forEach((track) => {
      track.stop();
    });
    // localStorage.setItem("reloaded", "1");
  },
});
